export default "__VITE_ASSET__36f0e12a__"